import {visitCount} from '@/helpers/api-helper'
import {store} from '@/store'
function perfExit (perfStat) {
  perfStat.elapsed.loading = performance.now() - perfStat.start.loading
  return perfStat
}
async  function onPageChange (toRoute, fromRoute) {
  // const routeName = toRoute.name
  const perfStat = { start: {}, elapsed: {} }
  perfStat.start.loading = performance.now()
  console.log('Pg', toRoute)

  const curr = toRoute.query.curr
  console.log('Currency = ', curr)

  switch (curr) {
  case 'ca':
    store.dispatch('system/setCurrencyCAD')
    break
  case 'us':
    store.dispatch('system/setCurrencyUSD')
    break
  case 'eu':
    store.dispatch('system/setCurrencyEU')
    break
  }


  /*
  Note that the browser settings can override the OS setting
   */
  const isDark = window.matchMedia('(prefers-color-scheme:dark)').matches
  console.log('isDark', isDark)

  try {
    perfStat.start.loadApi = performance.now()
    // console.log('TO DO load api data')
    await visitCount({pageTo: toRoute.path, pageFrom: fromRoute.path, hash: toRoute.hash, type: 'PAGE'})
    /*
        return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(results => {
          if(debug) console.log('GOT ', api, '>> ', results)
          resolve(results)
        })
        .catch(error => {
          let msg = `Get for ${url} failed`
          catchHandler(msg, error, reject)
        })
        .finally( () => {
          if(debug) console.log('GOT ', api, '>> finally')
          if (!silent) StoreHelper.setLoading('getRequest - not silent', false)
        })
    })


     */
    // const fromName = fromRoute.name
    // await store.dispatch('system/loadApiSystem', {from: fromName, to: routeName})
    // const apiData = store.getters['system/apiData']
    // perfStat.elapsed.loadApi = performance.now() - perfStat.start.loadApi
    // document.title = apiData.appTitle

  } catch (err) {
    console.error('PageController err', err)
    if (window.location.origin.includes('localhost')) console.error('stack:', err.stack)
  } finally {
  }
  return perfExit(perfStat)
}

export default  onPageChange
